/** Length of the sign-in code we mail out. */
export const EMAIL_CODE_LENGTH = 6;

/**
 * Pulls the sign-in code out of whatever was typed or pasted: "123 456",
 * "123456\n", a tab-separated copy from a table cell, or a whole line of the
 * email ("Your code is 123456. It expires in 10 minutes."). A standalone run of
 * six digits wins; otherwise every digit is kept, capped at six.
 */
export function extractEmailCode(text: string): string {
  const run = text.match(new RegExp(`(?<!\\d)\\d{${EMAIL_CODE_LENGTH}}(?!\\d)`));
  if (run) return run[0];
  return text.replace(/\D/g, "").slice(0, EMAIL_CODE_LENGTH);
}
